import { FormDialogProps } from 'interfaces/formDialog';
import { lazy, Suspense } from 'react';

const FormDialog = lazy(() => import('./FormDialog'));

const LazyFormDialog = (props: FormDialogProps) => (
  <Suspense fallback={null}>{props.open && <FormDialog {...props} />}</Suspense>
);

export default LazyFormDialog;
